module.exports = __webpack_public_path__ + "static/img/bg-en.9e3b894d.png";